import gql from 'graphql-tag';

// QUERIES

const getZonesQuery = gql`
  {
    zones: zones {
      _id
      name
      adminEmails
    }
  }
`;

const getMyZonesQuery = gql`
  query ($zoneIds: [ObjectId!]) {
    zones: zonesForIds(zoneIds: $zoneIds) {
      _id
      name
      adminEmails
    }
  }
`;

const getZonesPublicQuery = gql`
  {
    zones: zonesPublic {
      _id
    }
  }
`;

const getZoneQuery = gql`
  query ($_id: ObjectId!) {
    zone: zone(_id: $_id) {
      _id
      name
    }
  }
`;


const statAllOrdersQuery = gql`
  query ($fromDate: DateTime, $toDate: DateTime) {
    allOrders: statAllOrders(fromDate: $fromDate, toDate: $toDate) {
      #periods {
        #period
        #amount
        #number
      #}
      totalNumber
      #totalAmount
    }
  }
`;

const statAllOrdersForZonesQuery = gql`
  query ($fromDate: DateTime, $toDate: DateTime, $zoneIds: [ObjectId!]) {
    allOrders: statAllOrdersForZones(fromDate: $fromDate, toDate: $toDate, zoneIds: $zoneIds) {
      totalNumber
    }
  }
`;


// MUTATIONS

const addZoneMutation = gql`
  mutation(
    $name: String!
    $adminEmails: [String!]
    ) {
    createZone(
      name: $name
      adminEmails: $adminEmails,
      ) {
        name
    }
  }
`;

const updateZoneMutation = gql`
  mutation(
    $_id: ObjectId!
    $name: String!
    $adminEmails: [String!]
    ) {
    updateZone(
      _id: $_id,
      name: $name
      adminEmails: $adminEmails,
      ) {
        name
    }
  }
`;

export {
  getZonesQuery,
  getMyZonesQuery,
  getZonesPublicQuery,
  getZoneQuery,
  statAllOrdersQuery,
  statAllOrdersForZonesQuery,
  addZoneMutation,
  updateZoneMutation,
};
